import muster from '@dbk-legacy/muster'
import { variable } from '@dbk-legacy/muster/helpers'
import { getValues, watchValues, ref, call } from '@dbk-legacy/muster/utils'
import { encode } from 'base-64';
import Guid from '../utils/guid';
import isValidJsonString from '../utils/is-valid-json-string';
import { API_RESPONSE_CODES, SEPERATOR } from '../constants';

export default function () {
  return muster()
    .path('priceHistory.getData', {
      call: async ({ req }, { get, set, call }) => {
        let base64 = 'base64'
        const ran_str = "random" + Math.round(Math.random() * 1000);

        if (!req.args.length) {
          set('priceHistory.data', '');
          return;
        }
        try {
          base64 = encode(JSON.stringify(req.args[0]))
        } catch (e) {
          console.error(e)
        }
        const [valueMovements] = await getValues(get(`roster.data.priceHistory.getData.["${base64}"].["${ran_str}"]`));
        set('priceHistory.data', valueMovements);
      },
    })
     // this code is written for asset position chart for trading
     .path('priceHistory.getDataTrading', {
      call: async ({ req }, { get, set, call }) => {
        await Promise.all([
          set('priceHistory.fetchInProgress', true),
          set('priceHistory.data', '')
        ]);

        let base64 = 'base64'

        const guidStr = Guid();
        try {
          base64 = encode(JSON.stringify(req.args[0]))
        } catch (e) {
          console.error(e)
        }
        const [valueMovements] = await getValues(get(`roster.data.priceHistory.getData.["${base64}"].["${guidStr}"]`));

        await Promise.all([
          set('priceHistory.data', valueMovements),
          set('priceHistory.fetchInProgress', false)
        ]);
      },
    })

     // function to get asset detail when accordion is expanded
     .path('positionEntry.getSingleSecurityDetail', {
      call: async ({ req }, { get, set }) => {
        const ranStr = "random" + Math.round(Math.random() * 100);
       // const guidStr = Guid();
        const channel = 'DEVICE';
        const assetId = req.args[0];
        const inputParam = `${channel}${SEPERATOR}${assetId}`;
        await Promise.all([set('positionEntry.trade.security', null), set('positionEntry.trade.fetchInProgress', true)]);
        const [result] = await getValues(
          get(
            `${'roster.data.trades'}.getSingleSecurityDetail["${inputParam}"]["${ranStr}"]`
          )
        );
        isValidJsonString(result).then(async (data) => {
          if (data.responseCode === API_RESPONSE_CODES.SUCCESS) {
            await Promise.all([set('positionEntry.trade.security', data.asset ? data.asset : null),
            set('positionEntry.trade.fetchInProgress', false)]);
          }
          else {
            await set('positionEntry.trade.fetchInProgress', false);
          }
        }).catch(() => {
          set('positionEntry.trade.fetchInProgress', false)
        });
      }
    })

    .path('priceHistory.data', variable())
    .path('priceHistory.fetchInProgress', variable(false))
    .path('positionEntry.trade.security', variable(null))
    .path('positionEntry.trade.fetchInProgress', variable(false))

}
